import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Snackbar } from '@mui';
import { popDashboardMessage } from '@actions/dashboard-actions';

// The dialog snackbar relays dashboard snackbar messages to the shared Snackbar singleton
// so they display through the single Snackbar.Provider mounted at the app root.
const DialogSnackbar = () => {
  const dispatch = useDispatch();
  const { messages } = useSelector(state => state.dashboard.snackbar);
  const previousMessages = useRef(messages);

  useEffect(() => {
    const previousLength = previousMessages.current.length;
    if (messages.length > previousLength) {
      messages.slice(0, messages.length - previousLength).forEach(message => {
        Snackbar.info({
          message,
          autoHideDuration: 2500,
          onDismiss: () => dispatch(popDashboardMessage())
        });
      });
    }
    previousMessages.current = messages;
  }, [messages, dispatch]);

  return null;
};

export default DialogSnackbar;
